module.exports = __webpack_public_path__ + "img/who-are-we-img-4.d80af98e.png";